import { render, staticRenderFns } from "./DouceEscale.vue?vue&type=template&id=4569513c&scoped=true&"
import script from "./DouceEscale.vue?vue&type=script&lang=js&"
export * from "./DouceEscale.vue?vue&type=script&lang=js&"
import style0 from "./DouceEscale.vue?vue&type=style&index=0&id=4569513c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569513c",
  null
  
)

export default component.exports